<ion-header>
  <ion-toolbar mode="md" color="dark">
    <ion-title>Refunds</ion-title>
    <ion-buttons slot="end">
      <ion-button
        mode="md"
        debounce-click
        [debounceTime]="0"
        (debounceClick)="onCloseModal()"
        >Close</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen="true">
  <ion-grid class="ion-no-padding ion-no-margin">
    <ion-row class="refunds-modal">
      <ion-col size="12" sizeLg="7">
        <ion-accordion-group
          [class.ion-hide-md-down]="showTransactions"
          [class.ion-hide]="refundTicket && (!refundTicket.remaining_refund_due || refundTicket.status === 'completed')"
          class="refunds-modal__wizard"
          value="tender"
          animated="false">
          <ion-accordion
            value="tender"
            class="refunds-modal__wizard__tenders"
            toggle-icon-slot="start"
            [readonly]="hasOnlyOneTender">
            <ion-item
              slot="header"
              [color]="activeAccordionView === 'tender' ? 'blue' : 'whitesmoke'">
              <ion-label slot="start"
                ><strong>1. Select Tender Type</strong></ion-label
              >
              <ion-label
                [color]="activeAccordionView === 'tender' ? 'blue' : 'dark'"
                slot="end">
                <strong
                  >{{PAYMENT_REQUEST_TYPE_MAP[paymentTender?.type] | replace :
                  '_' : ' ' | titlecase}}</strong
                >
              </ion-label>
            </ion-item>
            <ion-list class="refunds-modal__methods" slot="content">
              <ion-item
                *ngFor="let tender of refundTicket?.available_refund_tenders"
                button
                detail
                color="whitesmoke"
                [disabled]="tender?.amount === '0' || isRefundInProgress"
                debounce-click
                [debounceTime]="0"
                (debounceClick)="onSelectTenderType(tender)"
                [id]="'method-' + tender?.type"
                lines="none">
                <ion-icon
                  [name]="PAYMENT_METHODS_MAP[tender?.type]?.icon"
                  slot="start"></ion-icon>
                <ion-label>
                  {{PAYMENT_REQUEST_TYPE_MAP[tender?.type] | replace : '_' : ' '
                  | titlecase}}<br />
                  <small
                    >Max amount: {{ tender?.amount | currency | negative
                    }}</small
                  ><br />
                  <small *ngIf="tender?.type === PAYMENT_TYPES.BILL_TO_ROOM"
                    >Room: {{ tender?.diner_name }}</small
                  >
                  <small *ngIf="tender?.type === PAYMENT_TYPES.GIFT_CARD"
                    >Gift Card: {{ tender?.gift_card_identification_number
                    }}</small
                  >
                  <small
                    *ngIf="tender?.type === PAYMENT_TYPES.CHARGE_ACCOUNT && tender?.department_id"
                    >Department: {{ tender?.department_id }}</small
                  >
                  <small
                    *ngIf="tender?.type === PAYMENT_TYPES.CHARGE_ACCOUNT && tender?.pos_charge_account_id"
                    >Charge Account: {{ tender?.pos_charge_account_id }}</small
                  >
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-accordion>
          <ion-accordion
            value="amount"
            class="refunds-modal__wizard__amount"
            [readonly]="!paymentTender"
            #amountAccordion>
            <ion-item
              slot="header"
              [color]="activeAccordionView === 'amount' ? 'blue' : 'whitesmoke'">
              <ion-label><strong>2. Enter a refund amount</strong></ion-label>
            </ion-item>
            <div slot="content">
              <ng-container [ngSwitch]="paymentTender?.type">
                <ng-container *ngSwitchCase="PAYMENT_TYPES.CASH">
                  <div
                    class="gc-options"
                    *ngIf="refundTicket?.status === 'pos_payment_location_missing'">
                    <ion-item>
                      <ion-label><strong>Payment Location</strong></ion-label>
                      <ion-select
                        placeholder="Select a Receipt Location"
                        interface="popover"
                        [value]="selectedPaymentLocation.id"
                        (ionChange)="selectPaymentLocation($event)">
                        <ion-select-option
                          *ngFor="let item of paymentLocations"
                          [value]="item.id">
                          {{item.name}} {{ !item.default_printer_id ? '' : ('| '
                          + (item.default_printer_id | printerById |
                          async)?.name) }}
                        </ion-select-option>
                      </ion-select>
                    </ion-item>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="PAYMENT_TYPES.GIFT_CARD">
                  <div class="gc-options">
                    <p>Gift Card Details</p>
                    <ion-item>
                      <ion-label><strong>Number</strong></ion-label>
                      <ion-label class="ion-text-right"
                        ><strong
                          >{{ paymentTender?.gift_card_identification_number
                          }}</strong
                        ></ion-label
                      >
                      <ion-buttons slot="end">
                        <ion-button
                          color="dark"
                          fill="solid"
                          debounce-click
                          [debounceTime]="0"
                          (debounceClick)="onChangeGiftCard()"
                          >Change</ion-button
                        >
                      </ion-buttons>
                    </ion-item>
                  </div>
                </ng-container>
                <ng-container
                  *ngSwitchCase="PAYMENT_TYPES.CREDIT_CARD_FREEDOMPAY">
                  <div
                    class="gc-options"
                    *ngIf="refundTicket?.status === 'freedompay_refund_required'">
                    <ion-item>
                      <ion-label
                        ><strong>FreedomPay Terminal</strong></ion-label
                      >
                      <ion-select
                        placeholder="Select a FreedomPay Terminal"
                        interface="popover"
                        [value]="selectedFreedomPayTerminalId"
                        (ionChange)="selectFreedomPayTerminal($event)">
                        <ion-select-option
                          *ngFor="let terminal of freedomPayTerminals"
                          [value]="terminal.id">
                          {{terminal.name}}
                        </ion-select-option>
                      </ion-select>
                    </ion-item>
                  </div>
                </ng-container>
              </ng-container>

              <p>Please enter the refund amount</p>
              <div class="pin-pad-container">
                <div>
                  <pos-numeric-keyboard
                    [value]="amount"
                    [buttons]="[]"
                    [negativeValues]="true"
                    [allowKeyboardInput]="allowKeyboardInput && !hasOnlyOneTender && !isRefundInProgress"
                    [disabled]="hasOnlyOneTender || isRefundInProgress"
                    (onValueChange)="onAmountChange($event)"></pos-numeric-keyboard>
                </div>
                <div *ngIf="activeAccordionView === 'amount'">
                  <ion-button
                    *ngIf="!hasOnlyOneTender"
                    mode="md"
                    color="danger"
                    expand="full"
                    id="cancel-payment"
                    [disabled]="isRefundInProgress"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onCancelTender()"
                    >Cancel</ion-button
                  >
                  <ion-button
                    mode="md"
                    color="success"
                    expand="full"
                    id="submit-payment"
                    [disabled]="!canSubmitPayment || isRefundInProgress"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="makeRefund()"
                    >Make Refund</ion-button
                  >
                </div>
              </div>
            </div>
          </ion-accordion>
        </ion-accordion-group>
      </ion-col>

      <ion-col
        size="12"
        sizeLg="5"
        [class.ion-hide-md-down]="!showTransactions && refundTicket?.remaining_refund_due">
        <div class="refunds-modal__details">
          <h1>Refund Transactions</h1>
          <div class="refunds-modal__details__transactions">
            <ng-container
              *ngIf="refundTicket?.existing_transactions && refundTicket?.existing_transactions?.length; else noTransactions">
              <ion-list>
                <ion-item
                  *ngFor="let transaction of refundTicket?.existing_transactions; let i = index"
                  [lines]="i === refundTicket?.existing_transactions?.length -1 ? 'none' : 'full'">
                  <ion-label>
                    <h2><strong>#{{transaction.id }}</strong></h2>
                    <h3>
                      {{PAYMENT_REQUEST_TYPE_MAP[transaction?.type] | replace :
                      '_' : ' ' | titlecase}}
                    </h3>
                    <h4
                      *ngIf="transaction?.type === PAYMENT_TYPES.BILL_TO_ROOM">
                      Billed {{transaction.amount | currency}} to
                      {{transaction.diner_name}}
                    </h4>
                  </ion-label>
                  <ion-label class="transaction-amount ion-text-right">
                    {{transaction.amount | currency | negative}}
                  </ion-label>
                </ion-item>
              </ion-list>
            </ng-container>

            <ng-template #noTransactions>
              <div class="no-transactions">
                You have not made any refund transactions yet.
              </div>
            </ng-template>
          </div>
          <div class="refunds-modal__details__total">
            <div class="refunds-modal__details__total__balance">
              <label>Refund Due</label>
              <label class="ion-text-right"
                >{{(refundTicket?.remaining_refund_due || 0) | currency}}</label
              >
            </div>
            <div *ngIf="!refundTicket?.remaining_refund_due">
              <ion-button
                color="medium"
                debounce-click
                [debounceTime]="0"
                (debounceClick)="onPrint()">
                <ion-icon slot="start" name="print-outline"></ion-icon>
                Print
              </ion-button>
              <ion-button
                color="dark"
                debounce-click
                [debounceTime]="0"
                (debounceClick)="onCloseModal()">
                Close
              </ion-button>
            </div>
          </div>
        </div>
      </ion-col>

      <ion-col
        size="12"
        class="ion-hide-md-up"
        *ngIf="refundTicket?.remaining_refund_due">
        <ion-button
          *ngIf="showTransactions"
          expand="full"
          color="orange"
          (click)="onShowTransactions()">
          <ng-container *ngIf="showTransactions;else notShowTransactions">
            Back to Payment
          </ng-container>
          <ng-template #notShowTransactions>
            <strong
              >Outstanding Balance {{refundTicket?.remaining_refund_due |
              currency}}</strong
            >
          </ng-template>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
